import React, { ReactNode } from 'react';
import { Box, AppBar, Toolbar, Typography, useTheme, useMediaQuery } from '@mui/material';
import InfoPanel from '../InfoPanel/InfoPanel';
import ControlPanel from '../Controls/ControlPanel';

interface MainLayoutProps {
  children: ReactNode;
}

const MainLayout: React.FC<MainLayoutProps> = ({ children }) => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));

  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', height: '100vh' }}>
      <AppBar 
        position="static" 
        sx={{ 
          backgroundColor: 'rgba(128, 128, 128, 0.95)',
          boxShadow: 'none',
          borderBottom: '1px solid rgba(0, 0, 0, 0.1)',
        }}
      >
        <Toolbar variant="dense">
          <Typography 
            variant={isMobile ? 'body1' : 'h6'} 
            component="h1" 
            sx={{ 
              flexGrow: 1,
              fontWeight: 600,
              letterSpacing: '-0.5px',
            }}
          >
            Life Within Boundaries
          </Typography>
          {!isMobile && (
            <Typography variant="body2" sx={{ opacity: 0.9 }}>
              Experience the geographic constraints of Gaza
            </Typography>
          )}
        </Toolbar>
      </AppBar>
      
      <Box sx={{ flexGrow: 1, position: 'relative', overflow: 'hidden' }}>
        {children}
        <InfoPanel />
        <ControlPanel />
      </Box>
    </Box>
  );
};

export default MainLayout;